import { type QueryCollectiblesArgs, type QueryCollectionsArgs } from '@pkg/graphql/codegen/graphql';
import { collectibles, collections } from '@pkg/graphql/queries';
import { type QueryProps } from '@pkg/types';

import { graphqlQuery } from '@app/client';

const callGetCollectibles = (params: QueryProps<QueryCollectiblesArgs>) =>
    graphqlQuery({
        ...params,
        query: collectibles,
    });

const callGetCollections = (params: QueryProps<QueryCollectionsArgs>) =>
    graphqlQuery({
        ...params,
        query: collections,
    });

export { callGetCollectibles, callGetCollections };
